module.exports = __webpack_public_path__ + "img/multiple-babies-pink.c1738ddc.svg";